import { Link, createFileRoute } from '@tanstack/react-router'
import { Button, Result } from 'antd'
import { ROUTE_PATHS } from '@/config/app.config'

/** 403 page shown inside the app shell when a route check fails. */
export const Route = createFileRoute('/_auth/unauthorized')({
  component: UnauthorizedPage,
})

function UnauthorizedPage() {
  return (
    <Result
      status="403"
      title="403"
      subTitle="You don't have permission to access this page :("
      extra={
        <Link to={ROUTE_PATHS.root}>
          <Button type="primary">Back to home</Button>
        </Link>
      }
    />
  )
}
